module.exports = __webpack_public_path__ + "static/media/Illus-Spring@2x.6538d9ca.png";